import { DeploymentStatus } from "../../common/models/DeploymentStatus";
import { ModelFactory } from "../../ModelFactory";
import { Task, taskFactory } from "./Task";

export class Deployment {
  constructor(
    public readonly id: string,
    public readonly entityId: string | null,
    public readonly entityName: string,
    public readonly type: string,
    public readonly description: string | null,
    public readonly status: DeploymentStatus,
    public readonly input: object,
    public readonly output: object | null,
    public readonly created: Date,
    public readonly updated: Date,
    public readonly started: Date | null,
    public readonly finished: Date | null,
    public readonly tasks: Task[],
    public readonly initiatedName: string | null
  ) {
  }
}

class DeploymentFactory extends ModelFactory<Deployment> {
  protected fromJson(json: any): Deployment {
    return new Deployment(
      json['id'],
      (json['entity']) ? json['entity']['id'] : null,
      (json['entity']) ? json['entity']['name'] : 'n/a',
      json['type'],
      json['description'] ?? null,
      json['status'],
      json['input'],
      json['output'] ?? null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['started_at'] ? new Date(json['started_at']) : null,
      json['finished_at'] ? new Date(json['finished_at']) : null,
      json['tasks'] ? taskFactory.fromItemsResponse(json['tasks']) : [],
      (json['initiated']) ? json['initiated']['first_name'] + ' ' + json['initiated']['last_name'] : null,
    );
  }
}
export const deploymentFactory = new DeploymentFactory();
